module.exports = __webpack_public_path__ + "img/bois1.98da4154.svg";